export default __webpack_public_path__ + "static/media/MWE.3a9b2de4.jpg";